import config from '../config';
import {
  loadUsers,
  loadLevels,
  loadUserById,
  updateUserPhotoThumb,
  addUser,
  addUserWithShop,
  updateUserById,
  removeUserById,
  loadUsersFailed, loadUserByIdForProfile,
  //unsetCurrentUser
} from '../actions/users';
import fetch from 'cross-fetch';
import store from 'store2';
import {addNotification as notify} from 'reapop';
import {push} from 'react-router-redux';

const EMPTY_USER_PHOTO_THUMB = '/assets/empty-user-photo.png';

export function fetchUsers() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/users`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadUsers({userList: json}));
          }
        })
        .catch(response => dispatch(loadUsersFailed({error: response})));
    }
  }
};

export function fetchUsersByRoleId(levelId, type) {
  return (dispatch) => {
    let userLevelId = '';
    if (levelId && type) {
      userLevelId = '?user_level_id=' + levelId;
    }
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/users${userLevelId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            let objUsers = {};
            objUsers[type] = json;

            dispatch(loadUsers({roleList: objUsers}));
          }
        })
        .catch(response => dispatch(loadUsersFailed({error: response})));
    }
  }
};

export function fetchLevels() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/users/getLevels`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadLevels({levelList: json}));
          }
        })
    }
  }
};

export function fetchUserById(id, isItForProfile, isPhotoThumbRequired) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {

      return fetch(`${config.apiEndpoint}/users/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            if (isItForProfile) {
              store.set('roleId', json.roleId);
              dispatch(loadUserByIdForProfile({userProfile: json}));
            } else {
              json.photoThumb = EMPTY_USER_PHOTO_THUMB;
              fetchUrl(`projectSalesMap/${id}/sales_person`)
                .then((response) => {
                  return response.json();
                })
                .then(customers => {
                  if (isPhotoThumbRequired){
                    fetchUrl(`/usersPhoto/getPhotoPreviewThumbnail/${id}`)
                      .then((response) => {
                        if (response.status == 200) {
                          response.blob().then(buffer => {
                            json.photoThumb = URL.createObjectURL(buffer);
                            dispatch(loadUserById({currentUser: json, customers}));
                          })
                        } else {
                          dispatch(loadUserById({currentUser: json, customers}));
                        }
                      }).catch(e => dispatch(loadUserById({currentUser: json, customers})));
                  } else {
                    dispatch(loadUserById({currentUser: json, customers}));
                  }
                });
            }
          }
          return json;
        })
    }
  }
};

export function fetchUserByIdForProfile(id) {
  return (dispatch) => {
    fetchUserById(id, true)(dispatch);
  }
};

export function createUser(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/users`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(addUser({user: json}));
            fetchUsers();
            dispatch(push('/pages/people'));
            dispatch(notify({
              title: 'Add New User',
              message: 'User added successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
            window.location.reload();
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Add New User',
            message: 'Failed to add new user',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function createUserWithShopId(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/users`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {

            dispatch(addUserWithShop({user: json}));
          }
        })
    }
  }
};

export function updateUser(id, data, remove=null, add=null, isSales=false) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/users/${id}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            if (json.code === 403) {
              dispatch(notify({
                title: 'Edit User',
                message: 'Failed to edit user. Access denied.',
                status: 'error',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            } else {
              if(remove && remove.length && isSales) {
                fetchUrl(`projectSalesMap/`, 'DELETE', {remove})
              }
              if(add && add.length && isSales) {
                fetchUrl(`projectSalesMap/save/${id}`, 'POST', {appoint_to: 'sales_person', add})
              }
              dispatch(notify({
                title: 'Edit User',
                message: 'User edited successfully',
                status: 'success',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Edit User',
            message: 'Failed to edit user',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function removeUser(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/users/${data.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(removeUserById({id: data.id}));
            dispatch(notify({
              title: 'Delete User Card',
              message: 'User deleted successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
};

export function uploadUserPhoto(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      const formData = new FormData();
      formData.append('image', data.img, data.img.name);

      const notifyError = error => {
        dispatch(notify({
          title: 'Upload User Photo',
          message: 'Failed to upload user photo',
          status: 'error',
          position: 'tr',
          dismissible: true,
          dismissAfter: 3000
        }));
        console.log(error);
      }

      return fetch(`${config.apiEndpoint}/usersPhoto/${data.id}`, {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      }).then(response => {
          if (response && response.status == 200) {
            fetchUrl(`/usersPhoto/getPhotoPreviewThumbnail/${data.id}`)
              .then((response) => {
                if (response.status == 200) {
                  response.blob().then(buffer => {
                    const photoThumb = URL.createObjectURL(buffer);
                    dispatch(updateUserPhotoThumb(photoThumb));
                  })
                } else {
                  notifyError(response);
                }
              }).catch(notifyError);
          } else {
            notifyError(response);
          }
        })
        .catch(notifyError);
    }
  }
};

export function removeUserPhoto(userId) {
  return (dispatch) => {

    const notifyError = e => {
        console.log(e);

        dispatch(notify({
          title: 'Delete User Card',
          message: 'User deleted successfully',
          status: 'success',
          position: 'tr',
          dismissible: true,
          dismissAfter: 3000
        }));
    };

    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/usersPhoto/${userId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then(response => {
          if (response.status == 200) {
            dispatch(updateUserPhotoThumb(EMPTY_USER_PHOTO_THUMB));
          } else {
            notifyError(response);
          }
        }).catch(notifyError);
    }
  }
};

const fetchUrl = (url, method = 'GET', data) => {
  return fetch(`${config.apiEndpoint}/${url}`, {
    method,
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `bearer ${store.get('user').api_token}`
    },
    credentials: 'same-origin'
  })
};



// WEBPACK FOOTER //
// ./src/api/users.js